import { Accordion } from 'react-bootstrap';
import DynamicViewEngine from '../dynamic-form/DynamicViewEngine';
import ViewSectionAccordeon from '../generic-component/ViewSectionAccordion';
import {
  isSectionVisible,
  showAccordionSectionBySome,
} from '../../app/helpers/helperValidationViewPreview';

/**
 * Secciones principal + secundaria.
 * - nested=true: sin Accordion/tabs; ambas secciones en flujo vertical (popup integrado).
 *   En ficha completa (isPreviewMode=false) muestra campos con show_view_full O show_view_preview.
 * - nested=false: Accordion alwaysOpen con ambas abiertas (defaultActiveKey ['0','1']).
 */
const sectionShouldRender = (list, isPreviewMode, nested) => {
  if (!list || list.length === 0) return false;
  if (nested) {
    // Popup: no depender solo del header (list[0]); si hay campos del modo, o en view cualquier flag.
    if (isPreviewMode) {
      return (
        isSectionVisible(list, true) || showAccordionSectionBySome(list, true)
      );
    }
    return (
      isSectionVisible(list, false) ||
      showAccordionSectionBySome(list, false) ||
      showAccordionSectionBySome(list, true)
    );
  }
  return (
    isSectionVisible(list, isPreviewMode) ||
    showAccordionSectionBySome(list, isPreviewMode)
  );
};

const DetailSectionsLayout = ({
  nested = false,
  isPreviewMode = false,
  arrayListPrincipal,
  arrayListSecondary,
  principalHeader,
  secondaryHeader,
  sharedViewProps,
}) => {
  const showPrincipal = sectionShouldRender(
    arrayListPrincipal,
    isPreviewMode,
    nested
  );
  const showSecondary = sectionShouldRender(
    arrayListSecondary,
    isPreviewMode,
    nested
  );

  // En nested+view: ficha completa = union de flags preview|full
  const engineProps = {
    ...sharedViewProps,
    isPreviewMode,
    forceCompleteFields: nested && !isPreviewMode,
  };

  if (nested) {
    return (
      <div className="nested-flat-sections">
        {showPrincipal && (
          <div className="nested-detail-section mb-4">
            {principalHeader && (
              <div className="nested-section-title mb-2">
                <ViewSectionAccordeon header={principalHeader} />
              </div>
            )}
            <div className="row">
              <DynamicViewEngine list={arrayListPrincipal} {...engineProps} />
            </div>
          </div>
        )}
        {showSecondary && (
          <div className="nested-detail-section nested-detail-section--secondary mb-4 pt-3 border-top">
            {secondaryHeader && (
              <div className="nested-section-title mb-2">
                <ViewSectionAccordeon header={secondaryHeader} />
              </div>
            )}
            <div className="row">
              <DynamicViewEngine list={arrayListSecondary} {...engineProps} />
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <Accordion defaultActiveKey={['0', '1']} flush alwaysOpen>
      {showPrincipal && (
        <Accordion.Item eventKey="0" className="accordionSeccion">
          <Accordion.Header>
            <ViewSectionAccordeon header={principalHeader} />
          </Accordion.Header>
          <Accordion.Body>
            <div className="row">
              <DynamicViewEngine list={arrayListPrincipal} {...engineProps} />
            </div>
          </Accordion.Body>
        </Accordion.Item>
      )}
      {showSecondary && (
        <Accordion.Item eventKey="1" className="accordionSeccion">
          <Accordion.Header>
            <ViewSectionAccordeon header={secondaryHeader} />
          </Accordion.Header>
          <Accordion.Body>
            <div className="row">
              <DynamicViewEngine list={arrayListSecondary} {...engineProps} />
            </div>
          </Accordion.Body>
        </Accordion.Item>
      )}
    </Accordion>
  );
};

export default DetailSectionsLayout;
